'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _entries = require('lodash/entries');

var _entries2 = _interopRequireDefault(_entries);

var _wixVodCards = require('@wix/wix-vod-cards');

var _wixVodCards2 = _interopRequireDefault(_wixVodCards);

var _module = require('@wix/wix-vod-annoto/dist/module');

var _module2 = _interopRequireDefault(_module);

var _hls = require('playable/dist/src/adapters/hls');

var _hls2 = _interopRequireDefault(_hls);

var _constants = require('playable/dist/src/constants');

var _reactPlayable = require('react-playable');

var _reactPlayable2 = _interopRequireDefault(_reactPlayable);

var _playerApiFacade = require('./player-api-facade');

var _playerApiFacade2 = _interopRequireDefault(_playerApiFacade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var findChangedProps = function findChangedProps(currentProps, previousProps) {
  var uniqKeys = (0, _uniq2.default)([].concat(_toConsumableArray(Object.keys(currentProps)), _toConsumableArray(Object.keys(previousProps))));

  return uniqKeys.filter(function (key) {
    return key !== 'children';
  }) // children is handled by React so we can skip it
  .reduce(function (acc, key) {
    if (!(0, _isEqual2.default)(currentProps[key], previousProps[key])) {
      return _extends({}, acc, _defineProperty({}, key, currentProps[key]));
    }

    return acc;
  }, {});
};

var makeConfigurationChanger = function makeConfigurationChanger(handlers) {
  return function (changes) {
    (0, _entries2.default)(changes).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          propName = _ref2[0],
          propValue = _ref2[1];

      if (handlers[propName]) {
        handlers[propName](propValue);
      }
    });
  };
};

var VODPlayer = (_temp = _class = function (_React$Component) {
  _inherits(VODPlayer, _React$Component);

  function VODPlayer() {
    _classCallCheck(this, VODPlayer);

    var _this = _possibleConstructorReturn(this, (VODPlayer.__proto__ || Object.getPrototypeOf(VODPlayer)).call(this));

    _this.onInit = function (playerInstance) {
      _this.player = playerInstance;
      _this.player.hidePictureInPictureControl();
    };

    _this.handleLoop = function (isLoop) {
      _this.player.setLoop(isLoop);
    };

    _this.handleMuted = function (muted) {
      if (muted) {
        _this.player.mute();
      } else {
        _this.player.unmute();
      }
    };

    _this.handlePlaysInline = function (isInline) {
      _this.player.setPlaysinline(isInline);
    };

    _this.handlePlayableChanges = function (targetProps) {
      var changes = findChangedProps(_this.props, targetProps);

      if (!(0, _isEmpty2.default)(changes)) {
        _this.changePlayerUI(changes);
      }

      return changes;
    };

    _this.handlePauseVideoOnFullScreenExit = function (isMobile) {
      if (isMobile) {
        _this.player.enablePauseVideoOnFullScreenExit();
      } else {
        _this.player.disablePauseVideoOnFullScreenExit();
      }
    };

    _this.handlePlaybackStateChanged = function (playbackState) {
      var _handlers;

      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onEnded = _this$props.onEnded;


      var handlers = (_handlers = {}, _defineProperty(_handlers, _constants.EngineState.PLAYING, onPlay), _defineProperty(_handlers, _constants.EngineState.PAUSED, onPause), _defineProperty(_handlers, _constants.EngineState.ENDED, onEnded), _handlers);

      if (handlers[playbackState]) {
        handlers[playbackState]();
      }
    };

    _this.handleLogoProperties = function (logo) {
      if (!logo) {
        _this.player.setLogo();
        return;
      }

      _this.player.setLogo(logo.src);
      _this.player.setAlwaysShowLogo(logo.showAlways);
    };

    _this.handlePlayAtFullScreen = function (playAtFullScreen) {
      if (playAtFullScreen) {
        _this.player.enterFullScreen();
      } else if (_this.player.isInFullScreen) {
        _this.player.exitFullScreen();
      }
    };

    _this.handleSetMainUIShouldAlwaysShow = function (setMainUIShouldAlwaysShow) {
      _this.player.setMainUIShouldAlwaysShow(setMainUIShouldAlwaysShow);
    };

    _this.handleOnTitleClick = function (onTitleClick) {
      return _this.player.setTitleClickCallback(onTitleClick);
    };

    _this.handleCanDownload = function (canDownload) {
      var onDownloadClick = _this.props.onDownloadClick;


      if (onDownloadClick && canDownload) {
        _this.player.setDownloadClickCallback(onDownloadClick);
        _this.player.showDownloadButton();
        return;
      }

      _this.player.setDownloadClickCallback();
      _this.player.hideDownloadButton();
    };

    _this.handleOnWatchOnSiteClick = function (onWatchOnSiteClick) {
      _this.player.setLogoClickCallback(onWatchOnSiteClick);
    };

    _this.handlePlaying = function (_ref3) {
      var isVideoPlayRequested = _ref3.isVideoPlayRequested,
          vidiUrls = _ref3.vidiUrls,
          isVideoPauseRequested = _ref3.isVideoPauseRequested;

      var shouldTriggerPlay = (0, _isEmpty2.default)(vidiUrls) ? false : isVideoPlayRequested;

      if (shouldTriggerPlay && isVideoPauseRequested) {
        console.warn('VODPlayer: isVideoPlayRequested and isVideoPauseRequested both true');
        return;
      }

      if (shouldTriggerPlay) {
        _this.player.play();
      }

      if (isVideoPauseRequested) {
        _this.player.pause();
      }
    };

    _this.makePlayableConfig = function (_ref4) {
      var isAnnotoModuleEnabled = _ref4.isAnnotoModuleEnabled,
          disableFullScreen = _ref4.disableFullScreen,
          hideOverlay = _ref4.hideOverlay,
          modules = _ref4.modules,
          hideMainUI = _ref4.hideMainUI;
      return {
        modules: _extends({
          cards: _wixVodCards2.default
        }, isAnnotoModuleEnabled && { annoto: _module2.default }, modules),
        disableFullScreen: disableFullScreen,
        playbackAdapters: [_hls2.default],
        hideOverlay: hideOverlay,
        hideMainUI: hideMainUI
      };
    };

    _this.convertToPlayableSrc = (0, _memoize2.default)(function (urls) {
      return (0, _map2.default)(urls, function (_ref5) {
        var url = _ref5.url,
            type = _ref5.type;
        return {
          url: url,
          type: type
        };
      });
    });


    _this.player = null;

    _this.changePlayerUI = makeConfigurationChanger({
      logo: _this.handleLogoProperties,
      playAtFullScreen: _this.handlePlayAtFullScreen,
      onTitleClick: _this.handleOnTitleClick,
      canDownload: _this.handleCanDownload,
      onWatchOnSiteClick: _this.handleOnWatchOnSiteClick,
      setMainUIShouldAlwaysShow: _this.handleSetMainUIShouldAlwaysShow,
      mobileMode: _this.handlePauseVideoOnFullScreenExit,
      muted: _this.handleMuted,
      playInline: _this.handlePlaysInline,
      loop: _this.handleLoop
    });
    return _this;
  }

  _createClass(VODPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.changePlayerUI(this.props);
      this.handlePlaying(this.props);
      this.props.onInit(this.player);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var changes = this.handlePlayableChanges(prevProps);

      if (changes.isVideoPlayRequested || changes.isVideoPauseRequested) {
        this.handlePlaying(this.props);
      }
    }

    /**
     * ReactPlayable will do shallow compare of it's props,
     * so we need to persist this array
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onUserSeek = _props.onUserSeek,
          onSeek = _props.onSeek,
          onMuteChange = _props.onMuteChange,
          onVolumeChange = _props.onVolumeChange,
          vidiUrls = _props.vidiUrls,
          autoPlay = _props.autoPlay,
          preload = _props.preload,
          fillAllSpace = _props.fillAllSpace,
          videoItem = _props.videoItem,
          canShowTitle = _props.canShowTitle,
          texts = _props.texts,
          width = _props.width,
          height = _props.height,
          posterUrl = _props.posterUrl,
          onPlayAbort = _props.onPlayAbort,
          onError = _props.onError,
          onFullScreenChanged = _props.onFullScreenChanged;


      var config = this.makePlayableConfig(this.props);
      var src = this.convertToPlayableSrc(vidiUrls);

      return _react2.default.createElement(
        _reactPlayable2.default,
        {
          width: width,
          height: height,
          fillAllSpace: fillAllSpace,
          src: src,
          autoplay: autoPlay,
          preload: preload,
          title: canShowTitle ? videoItem.title : null,
          poster: posterUrl,
          texts: texts,
          config: config,
          onInit: this.onInit
        },
        _react2.default.createElement(
          _playerApiFacade2.default,
          {
            onFullScreenChanged: onFullScreenChanged,
            onPlaybackStateChanged: this.handlePlaybackStateChanged,
            onUserSeek: onUserSeek,
            onSeek: onSeek,
            onMute: onMuteChange,
            onVolumeChange: onVolumeChange,
            onPlayAbort: onPlayAbort,
            onError: onError
          },
          children
        )
      );
    }
  }]);

  return VODPlayer;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  channelData: _propTypes2.default.object,
  videoItem: _propTypes2.default.object,
  vidiUrls: _propTypes2.default.array,
  className: _propTypes2.default.string,
  mobileMode: _propTypes2.default.bool,
  playAtFullScreen: _propTypes2.default.bool,
  playInline: _propTypes2.default.bool,
  loader: _propTypes2.default.bool,

  preload: _propTypes2.default.string,

  canShowTitle: _propTypes2.default.bool,
  onTitleClick: _propTypes2.default.func,

  width: _propTypes2.default.number,
  height: _propTypes2.default.number,

  onInit: _propTypes2.default.func,
  onUserSeek: _propTypes2.default.func,
  onSeek: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onEnded: _propTypes2.default.func,
  onPlayAbort: _propTypes2.default.func,
  onFullScreenChanged: _propTypes2.default.func,
  onAnomalyDetected: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onMuteChange: _propTypes2.default.func,
  onVolumeChange: _propTypes2.default.func,

  canDownload: _propTypes2.default.bool,
  onDownloadClick: _propTypes2.default.func,

  setMainUIShouldAlwaysShow: _propTypes2.default.bool,
  muted: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  loop: _propTypes2.default.bool,

  isVideoPlayRequested: _propTypes2.default.bool,
  isVideoPauseRequested: _propTypes2.default.bool,
  onWatchOnSiteClick: _propTypes2.default.func,
  posterUrl: _propTypes2.default.string,

  texts: _propTypes2.default.object,
  isAnnotoModuleEnabled: _propTypes2.default.bool,
  disableFullScreen: _propTypes2.default.bool,
  hideOverlay: _propTypes2.default.bool,
  hideMainUI: _propTypes2.default.bool,
  modules: _propTypes2.default.object
}, _class.defaultProps = {
  width: 640,
  height: 360,
  mobileMode: false,
  logo: null,

  preload: 'metadata',

  canShowTitle: true,

  onPause: _noop2.default,
  onPlay: _noop2.default,
  onEnded: _noop2.default,
  onPlayAbort: _noop2.default,

  onVideoInfoShow: _noop2.default,
  onBuyRentButtonClick: _noop2.default,
  onShareVideoShow: _noop2.default,
  onFullScreenChanged: _noop2.default,
  onWatchOnSiteClick: _noop2.default,
  onMuteChange: _noop2.default,
  onVolumeChange: _noop2.default,

  onSeek: _noop2.default,
  onUserSeek: _noop2.default,

  onError: _noop2.default,
  onInit: _noop2.default,
  onAnomalyDetected: _noop2.default,
  isAnnotoEnabled: false,
  disableFullScreen: false,
  hideOverlay: true
}, _temp);
exports.default = VODPlayer;
module.exports = exports['default'];